import { createSlice } from '@reduxjs/toolkit';
import PeopleIcon from '@mui/icons-material/People';
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';
import PermMediaOutlinedIcon from '@mui/icons-material/PhotoSizeSelectActual';
import PublicIcon from '@mui/icons-material/Public';
import SettingsIcon from '@mui/icons-material/Settings';
import HomeIcon from '@mui/icons-material/Home';

// Slice עבור דף הבית
export const homePageSlice = createSlice({
  name: 'homePage',
  initialState: {
    data: [
      { id: 0, name: 'דף הבית', icon: <HomeIcon />, navigator: 'bookkeepingDashboard', active: true, permissions: [1,3], userId: [74] },
      { id: 1, name: 'דף הבית', icon: <HomeIcon />, navigator: 'cemetery', active: true, permissions: [1], userId: [73] },
    ],
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})
// Slice עבור התפריט
export const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    NAME_APP: 'חברה קדישא',
    NAME_CATEGORY_GRAVES: 'ניהול קברים',
    NAME_CATEGORY_CUSTOMERS: 'ניהול לקוחות',
    NAME_CATEGORY_PYTMENTS: 'ניהול מחירים',
    NAME_CATEGORY_REPORTS: 'ניהול דוחות',
    NAME_CEMETERY: 'בתי עלמין',
    NAME_BLOCK: 'גושים',
    NAME_PLOT: 'חלקות',
    NAME_AREA_GRAVE: 'אחוזות קבר',
    NAME_CUSTOMER: 'לקוחות',
    NAME_PURCHASE: 'רכישות',
    NAME_BURIAL: 'קבורות',
    NAME_PAYMENT: 'מחירים',
    NAME_REPORTS: 'דוחות',
    categories: [
      {

        id: 'ניהול קברים',
        permissions: [1],
        children: [
          { id: 'בתי עלמין', icon: <PeopleIcon />, navigator: 'cemetery', active: true },
          { id: 'גושים', icon: <DnsRoundedIcon />, navigator: 'block', },
          { id: 'חלקות', icon: <PermMediaOutlinedIcon />, navigator: 'plot', },
          { id: 'אחוזות קבר', icon: <PublicIcon />, navigator: 'areaGrave', },
        ],
      },
      {
        id: 'ניהול לקוחות',
        permissions: [1],
        children: [
          { id: 'לקוחות', icon: <PeopleIcon />, navigator: 'customer', active: true },
          { id: 'רכישות', icon: <DnsRoundedIcon />, navigator: 'purchase', },
          { id: 'קבורות', icon: <PermMediaOutlinedIcon />, navigator: 'burial', },
        ],
      },
      {
        id: 'ניהול מחירים',
        permissions: [1],
        children: [
          { id: 'מחירים', icon: <PeopleIcon />, navigator: 'payment', active: true },
        ],
      },
      {
        id: 'ניהול דוחות',
        permissions: [1],
        children: [
          { id: 'דוחות', icon: <PeopleIcon />, navigator: 'reports', active: true },
        ],
      },
      {
        id: 'משימות',
        permissions: [3],
        children: [
          { id: 'רכישות פתוחות', icon: <SettingsIcon />, navigator: 'bookkeepingDashboard', },
        ],
      },
      {
        id: 'כתובות',
        permissions: [1],
        children: [
          { id: 'countryCreate', icon: <SettingsIcon />, navigator: 'countryCreate', },
          { id: 'cityCreate', icon: <SettingsIcon />, navigator: 'cityCreate', }
        ],
      },
      {
        id: 'test',
        permissions: [1],
        children: [
          { id: 'globalSearch', icon: <SettingsIcon />, navigator: 'globalSearch', },
          { id: 'bookkeepingDashboard', icon: <SettingsIcon />, navigator: 'bookkeepingDashboard', },
          { id: 'component', icon: <SettingsIcon />, navigator: 'component', },
        ],
      },
    ],
  },
  reducers: {
    setCategories(state, action) {
      state.categories = action.payload;
    },
    setActiveRoute(state, action) {
      const { categoryId, childId } = action.payload;
      state.categories = state.categories.map(category => {
        if (category.id === categoryId) {
          return {
            ...category,
            children: category.children.map(child => ({
              ...child,
              active: child.id === childId,
            })),
          };
        }
        return category;
      });
    },
  },
});

// export const { setCategories, setActiveRoute } = menuSlice.actions;
export const menuActions = menuSlice.actions
// export default menuSlice.reducer;

// export const columnsFormPaymentsActions = columnsFormPaymentsSlice.actions
// export const categoryPaymentsActions = categoryPaymentsSlice.actions





